import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import companyData from "../../companyData";
// footer

const Footer = () => {
  const [showFollowUs, setShowFollowUs] = useState(() => window.innerWidth <= 576);
  const [showHereToHelp, setShowHereToHelp] = useState(() => window.innerWidth <= 576);
  const [showCustomerService, setShowCustomerService] = useState(() => window.innerWidth <= 576);

  useEffect(() => {
    updateStates();
    window.addEventListener("resize", updateStates);
    return () => {
      window.removeEventListener("resize", updateStates);
    };
  }, []);

  const updateStates = () => {
    if (window.innerWidth <= 576) {
      setShowFollowUs(true);
      setShowHereToHelp(true);
      setShowCustomerService(true);
    } else {
      setShowFollowUs(true);
      setShowHereToHelp(true);
      setShowCustomerService(true);
    }
  };

  const toggleFollowUs = () => {
    if (window.innerWidth <= 576) {
      setShowFollowUs((prevState) => !prevState);
    }
  };

  const toggleHereToHelp = () => {
    if (window.innerWidth <= 576) {
      setShowHereToHelp((prevState) => !prevState);
    }
  };

  const toggleCustomerService = () => {
    if (window.innerWidth <= 576) {
      setShowCustomerService((prevState) => !prevState);
    }
  };

  const DisplayingErrorMessagesSchema = Yup.object().shape({
    phone: Yup.string()
      .required("Please enter your phone number")
      .matches(
        /^(07|\+2547)[0-9]{8}$/,
        "Please enter a valid Kenyan phone number.",
      ),
  });


  const submitHandler = (submitdata) => {
    // Existing implementation remains unchanged
  };

  // Structured data for LocalBusiness
  const businessStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: companyData.name,
    image: companyData.logo,
    telephone: companyData.phone,
    email: companyData.email,
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Nakuru Wilmur house room 11, Kenyatta avenue,Next To Family Bank",
      addressLocality: "Nakuru",
      addressRegion: "Rift Valley",
      postalCode: "20100",
      addressCountry: "KE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "-0.303099",
      longitude: "36.080026",
    },
    url: window.location.href,
    openingHours: "Mo-Su 08:00-17:30",
    priceRange: "$$",
    sameAs: [
      companyData.facebook,
      companyData.instagram,
      companyData.tiktok,
      `https://wa.me/${companyData.whatsapp}`,
    ],
  };

  return (
    <>
      {/* Structured data for search engines */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(businessStructuredData),
        }}
      />

      <section className="py-3 py-md-5 py-xl-10 bg-light">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12 col-md-9 col-lg-8 col-xl-7 col-xxl-6">
              <h3 className="display-10 mb-2 text-center">
                Get Security Solutions Updates in Nakuru
              </h3>
            </div>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-12 col-md-10 col-lg-9 col-xl-8 col-xxl-7">
              <Formik
                initialValues={ {phone: ""}}
                validationSchema={DisplayingErrorMessagesSchema}
                onSubmit={submitHandler}
              >
                {({ errors, touched }) => (
                  <Form className="row gy-3 gy-lg-0 gx-lg-2 justify-content-center">
                    <div className="col-12 col-lg-8">
                      <label htmlFor="phone" className="visually-hidden">
                        Kenyan Phone Number
                      </label>
                      <Field
                        name="phone"
                        placeholder="+2547XX XXX XXX"
                        className="form-control"
                        type="text"
                        id="phone"
                        aria-label="Enter Kenyan phone number for security updates"
                      />
                      {touched.phone && errors.phone && (
                        <div className="text-danger ms-2 small-font-size">
                          {errors.phone}
                        </div>
                      )}
                      <div
                        id="email-newsletter-help"
                        className="form-text text-center text-lg-start"
                      >
                        We'll never share your phone number with anyone else.
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 text-center text-lg-start">
                      <button
                        type="submit"
                        className="btn btn-primary bsb-btn-3xl"
                        aria-label="Subscribe to security updates"
                      >
                        Subscribe
                       
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </section>

      <footer
        className=""
        itemScope
        itemType="https://schema.org/LocalBusiness"
      >
        <meta itemProp="name" content={companyData.name} />
        <meta itemProp="telephone" content={companyData.phone} />
        <meta itemProp="email" content={companyData.email} />
        <meta itemProp="url" content={window.location.href} />

        <div className="container">
          <div className="row footer-top">
            <div className="col-lg-5 col-md-6 col-sm-12 mb-4">
              <img
                src={companyData.logo}
                alt={`${companyData.name} security solutions logo in Nakuru`}
                style={{
                  width: "6rem",
                  filter: "brightness(0) invert(1)",
                  WebkitFilter: "brightness(0) invert(1)",
                }}
                itemProp="image"
              />
              <p className="pt-4 footer-color" itemProp="description">
                {companyData.name} - Premier Security Solutions Provider in
                Nakuru, Kenya
              </p>
              <h6
                className="text-light footer-toggle d-sm-none d-flex "
                onClick={toggleFollowUs}
              >
                Follow Us{" "}
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={`icon ${
                    showFollowUs ? "icon-rotate" : ""
                  } hover-color-yellow`}
                  aria-hidden="true"
                />
              </h6>{" "}
              <div className={`footer-content ${showFollowUs ? "show" : ""}`}>
                <h6 className="text-light d-none d-sm-block ">Follow Us</h6>
                <div className="social-icons d-flex flex-wrap">
                  <a
                    href={`${companyData.instagram}`}
                    target="__blank"
                    className="me-4 link-light  hover-color-yellow"
                    aria-label="Follow us on Instagram"
                    itemProp="sameAs"
                  >
                    <FontAwesomeIcon
                      icon={faInstagram}
                      size="lg"
                      className="hover-color-yellow"
                    />
                  </a>
                  <a
                    href={`${companyData.facebook}`}
                    target="__blank"
                    className="me-4 link-light"
                    aria-label="Follow us on Facebook"
                    itemProp="sameAs"
                  >
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      size="lg"
                      className="hover-color-yellow"
                    />
                  </a>
                  <a
                    href={`${companyData.tiktok}`}
                    target="__blank"
                    className="me-4 link-light"
                    aria-label="Follow us on TikTok"
                    itemProp="sameAs"
                  >
                    <FontAwesomeIcon
                      icon={faTiktok}
                      size="lg"
                      className="hover-color-yellow"
                    />
                  </a>
                  <a
                    href={`https://wa.me/+254${companyData.whatsapp}`}
                    target="__blank"
                    className="me-4 link-light"
                    aria-label="Chat with us on WhatsApp"
                    itemProp="sameAs"
                  >
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      size="lg"
                      className="hover-color-green"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <h6
                className="text-light footer-toggle d-sm-none"
                onClick={toggleHereToHelp}
              >
                HERE TO HELP{" "}
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={`icon ${
                    showHereToHelp ? "icon-rotate" : ""
                  } hover-color-yellow`}
                  aria-hidden="true"
                />
              </h6>
              <h6 className="text-light d-none d-sm-block">HERE TO HELP</h6>

              <div className={`footer-content ${showHereToHelp ? "show" : ""}`}>
                <div>
                  <p className="pt-1 footer-color">
                    Security Solutions Support in Nakuru
                  </p>
                </div>
                <div>
                  <p className="d-flex">
                    <p itemProp="telephone">
                      <span className="text-light d-block pt-1">
                        Order by phone
                      </span>

                      <span className="d-block footer-color">
                        Available everyday
                      </span>

                      <span className="contacts">
                        <a
                          href={`tel:${companyData.phone}`}
                          className=" hover-color-yellow footer-color"
                          aria-label="Call our security solutions team"
                        >
                          {companyData.phonespace}
                        </a>
                      </span>
                    </p>
                  </p>
                </div>
                <div>
                  <p className="d-flex">
                    <p itemProp="email">
                      <span className="text-light d-block pt-1">Email Us</span>

                      <span className="d-block footer-color">
                        Get security support by email
                      </span>

                      <span className="contacts">
                        <a
                          href={`mailto:${companyData.email}`}
                          className=" hover-color-yellow footer-color"
                          aria-label="Email our security team"
                        >
                          {companyData.email}
                        </a>
                      </span>
                    </p>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <h6
                className="text-light footer-toggle d-sm-none"
                onClick={toggleCustomerService}
              >
                Security Services{" "}
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={`icon ${
                    showCustomerService ? "icon-rotate" : ""
                  } hover-color-yellow`}
                  aria-hidden="true"
                />
              </h6>
              <h6 className="text-light d-none d-sm-block ">
                Security Services
              </h6>

              <div
                className={`footer-content ${
                  showCustomerService ? "show" : ""
                }`}
              >
                <div>
                  <p className="menu-footer pt-3">
                    <Link
                      to="/contact"
                      className="footer-color link hover-color-yellow "
                      aria-label="Contact security solutions provider"
                    >
                      Contact Us
                    </Link>
                  </p>
                  <p className="menu-footer">
                    <Link
                      to="/faq"
                      className="footer-color link hover-color-yellow"
                      aria-label="Security solutions FAQ"
                    >
                      Security FAQs
                    </Link>
                  </p>
                  <p className="menu-footer">
                    <Link
                      to="/"
                      className="footer-color link hover-color-yellow"
                      aria-label="Download our security app"
                    >
                      Download App
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="raw">
          <hr className="footer-color" />
          <div className="col-12 col-sm pt-2 pb-3 d-flex justify-content-center justify-content-sm-center text-center footer-color">
            <h6 style={{ fontSize: "11px", marginBottom: "45px" }}>
              © {new Date().getFullYear()} Copyright - {companyData.name}. All
              Rights Reserved. Nakuru, Kenya | Design By{" "}
              <a
                href="http://websites.threedolts.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Website design by ThreeDolts"
              >
                websites.threedolts.com
              </a>
            </h6>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
